// extracted by mini-css-extract-plugin
module.exports = {"root":"index__root___2z7vN"};